import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const EmployeesAssetsReportFilters = ({
  handleSubmit = () => {},
  handleValueChange = () => {},
  t,
  values = {},
}) => {
  return (
    <form
      onSubmit={(e) => {
        e && e.preventDefault();
        handleSubmit();
      }}
      noValidate
      autoComplete="false"
    >
      {/* <div className="row mt-3"> */}
      <div className="w-100">
        <Form.FieldInput
          autoFocus={true}
          name={'fulltext'}
          placeholder={t('actions.search')}
          handleChange={handleValueChange}
          iconRight="search"
          t={t}
          value={values.fulltext}
          extraClassName="icon-right"
        />
      </div>
      {/* </div> */}
    </form>
  );
};

export default translate()(EmployeesAssetsReportFilters);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/employees_assets/EmployeesAssetsReportFilters.js